export class Receipt {

	receiptDescription: any;
	receiptId: any;
	receiptType: ReceiptType;
	receiptLabel: any;
	value: number;
	date: string;
	transactionId: any;
	newReceipt: boolean;

	constructor() {

	}
}

export enum ReceiptType{
	TED = 'TED',
	ENTRECONTAS = 'EntreContas',
	DOC	= 'DOC',
	BOLETO = 'Boleto',
	DARF = 'DARF',
	GPS = 'GPS',
	Convenio = 'Convenio',
	DEBITO_AUTORIZADO = 'DebitoAutorizado',
	PIX = 'PIX',
	PIX_DEVOLVIDO = 'PIXDevolvido',
	RECARGA = 'Recarga'
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/receipts/models/receipt.ts